import httpService from '@Utils/httpService';

const baseUrl = 'api/FacilityGroups';

export default {
  get(params = {}) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getByCompanyId(companyId,params = {}) {
    return httpService.get({
      url: `${baseUrl}/ByCompany/${companyId}`,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  
  create(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  
  update(data) {
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  
  delete(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  }
};
